export default class NumberInput extends React.Component {
  constructor(props) {
    super();
    this.state = {
      value: props.value || '',
      focused: false
    };
  }

  render() {
    const classes = classNames({
      'show-labelholder': this.state.value,
      'focused': this.state.focused,
    }, 'labelholder')
    return (
      <div className={classes}
            data-label={this.props.placeholder || ''}>
        <input type="text"
                className={`form-control ${this.state.value ? 'has-value': ''}`}
                value={this.state.value}
                onChange={this._input.bind(this)}
                onFocus={() => this.setState({focused: true})}
                onBlur={() => this.setState({focused: false})}
                name={this.props.name}
                placeholder={this.props.placeholder || ''}
                id={this.props.field}/>
        <div className="remover" onClick={this._clear.bind(this)}></div>
      </div>
    );
  }

  _input(e) {
    if (e.target.value.match(/^\d+$/) || e.target.value === '')
      this.setState({value: e.target.value})
  }

  _clear() {
    this.setState({value: null})
  }
}

NumberInput.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  field: PropTypes.string.isRequired,
  value: PropTypes.string
};

